module.exports = __webpack_public_path__ + "img/4.518fc7b0.png";